import React from "react";
import _ from "lodash";
import Modal from "../base/Modal";
import TabBar from "../base/TabBar";
import provideDomainSettings from "../providers/DomainSettingsProvider";

import UIActions from "../../actions/UIActions";
import DomainSettingsActions from "../../actions/DomainSettingsActions";
import AppConstants from "../../constants/AppConstants";

import DomainPanel from "./DomainPanel";
import RedirectsPanel from "./RedirectsPanel";
import { toUnicode } from "../../utils/DomainUtils";

class DomainSettingsModal extends React.Component {
  constructor(props) {
    super(props);

    this._close = this._close.bind(this);
    this._changeTab = this._changeTab.bind(this);
  }

  _close() {
    UIActions.modalClose(AppConstants.MODAL_DOMAIN_SETTINGS);
  }

  _changeTab(tab) {
    DomainSettingsActions.changeTab(tab);
  }

  render() {
    let modalProps = _.pick(this.props, Modal.BASIC_PROPS);
    let { domainSettingsData } = this.props;
    let tab = domainSettingsData.get("tab");
    let working = domainSettingsData.get("working");
    let optionTabEnabled = domainSettingsData.get("optionTabEnabled");

    let tabContent = null;

    let domainData = domainSettingsData.get("domain");
    let domain = domainData.getIn(["current"]);
    let domainName = domain.get("domain_name", "Unknown");

    let tabs = [{ id: "redirects", label: "Redirects" }];

    if (optionTabEnabled) {
      tabs.unshift({ id: "domain", label: "Settings" });
    }

    switch (tab) {
      case "domain":
        let domainPanel = domainSettingsData.get("domainPanel");

        tabContent = (
          <DomainPanel
            domainSettings={domainData}
            panelSettings={domainPanel}
            onClose={this._close}
          />
        );
        break;
      case "redirects":
        let redirects = domainSettingsData.get("redirects");
        let redirectsPanel = domainSettingsData.get("redirectsPanel");

        tabContent = (
          <RedirectsPanel
            redirects={redirects}
            panelSettings={redirectsPanel}
            domainName={domainName}
            onClose={this._close}
          />
        );
        break;
    }

    return (
      <Modal {...modalProps}>
        <Modal.Dialog size="medium">
          <Modal.Dialog.Header closeButton>
            <Modal.Dialog.Title>Domain Configuration</Modal.Dialog.Title>
          </Modal.Dialog.Header>
          <Modal.Dialog.Body
            style={{ padding: 0, minHeight: 520, display: "flex", flexFlow: "column" }}
          >
            <div style={{ margin: 8, marginLeft: 12 }}>
              <span style={{ fontSize: 18 }}>{toUnicode(domainName || "")}</span>
              <p className={"instrux"} style={{ margin: 0 }}>
                To make changes live please Publish again.
              </p>
            </div>
            <TabBar tabs={tabs} selectedTab={tab} onSelect={this._changeTab} />
            {tabContent}
          </Modal.Dialog.Body>
        </Modal.Dialog>
      </Modal>
    );
  }
}

export default provideDomainSettings(DomainSettingsModal);
